
export enum RouteEquipmentTypeCd {
	DOLLY = 'Dolly',
	OTHER = 'Other',
	POWER_TRACTOR = 'PowerTractor',
	STRAIGHT_TRUCK = 'StraightTruck',
	TRAILER = 'Trailer'}

